<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
    <app-form
        [(values)]="mutationsInputs.values"
        title="{{ title }}"
        [formBlueprint]="mutationsInputs.formBlueprint"
        (cancel)="cancel()"
        (confirm)="confirm($event)"
        [isDialog]="true"
        [context]="context"
    >
    </app-form>
</mat-dialog-content>
